import AvailabilityBanner from './availability-banner';
import NavBar from './nav-bar';

const Header = () => {
  return (
    <header className="w-full">
      <AvailabilityBanner />
      <NavBar />
    </header>
  );
};

export default Header;
